import axios from "axios";

import { API_BASE_URL } from "../../config";

const initialSetupClient = axios.create({ baseURL: API_BASE_URL });

initialSetupClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function getInitialSetupOpeningDays() {
  const response = await initialSetupClient.get("/api/web/initial-setup/opening-days");
  return response.data;
}

export async function updateInitialSetupOpeningDays(payload) {
  const response = await initialSetupClient.put("/api/web/initial-setup/opening-days", payload);
  return response.data;
}

export async function getInitialSetupDepartments() {
  const response = await initialSetupClient.get("/api/web/initial-setup/departments");
  return response.data;
}

export async function updateInitialSetupDepartments(payload) {
  const response = await initialSetupClient.put("/api/web/initial-setup/departments", payload);
  return response.data;
}

export async function getInitialSetupShifts() {
  const response = await initialSetupClient.get("/api/web/initial-setup/shifts");
  return response.data;
}

export async function updateInitialSetupShifts(payload) {
  const response = await initialSetupClient.put("/api/web/initial-setup/shifts", payload);
  return response.data;
}

export async function getInitialSetupTypeSettings() {
  const [absenceResponse, holidayResponse] = await Promise.all([
    initialSetupClient.get("/api/web/initial-setup/absence-types"),
    initialSetupClient.get("/api/web/initial-setup/holiday-types"),
  ]);
  return { ...absenceResponse.data, ...holidayResponse.data };
}

async function mutateType(request) {
  await request();
  return getInitialSetupTypeSettings();
}

export function createInitialSetupAbsenceType(payload) {
  return mutateType(() => initialSetupClient.post("/api/web/initial-setup/absence-types", payload));
}

export function updateInitialSetupAbsenceType(id, payload) {
  return mutateType(() => initialSetupClient.put(`/api/web/initial-setup/absence-types/${id}`, payload));
}

export function deleteInitialSetupAbsenceType(id) {
  return mutateType(() => initialSetupClient.delete(`/api/web/initial-setup/absence-types/${id}`));
}

export function createInitialSetupHolidayType(payload) {
  return mutateType(() => initialSetupClient.post("/api/web/initial-setup/holiday-types", payload));
}

export function updateInitialSetupHolidayType(id, payload) {
  return mutateType(() => initialSetupClient.put(`/api/web/initial-setup/holiday-types/${id}`, payload));
}

export function deleteInitialSetupHolidayType(id) {
  return mutateType(() => initialSetupClient.delete(`/api/web/initial-setup/holiday-types/${id}`));
}
